<template>
  <v-layout row wrap>
    <v-toolbar dense class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold">
        Proposal Designer
      </v-toolbar-title>
    </v-toolbar>
    <v-flex xs12>
      <v-jsoneditor
        v-model="proposals"
        :options="jsonOptions"
        height="400px"
        :plus="true"
        key="jsonEditor"
      >
      </v-jsoneditor>
    </v-flex>

    <v-flex xs12 class="pt-4">
      <v-card>
        <v-toolbar dense card class="elevation-2">
          <v-toolbar-title class="body-2 beez-bold">
            Proposal Preview
          </v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          The Proposal screen updates as the JSON is edited
        </v-card-title>
        <proposal-renderer
          :proposals="proposals"
          :readonly="true"
          :cancel="true"
          key="renderer"
        >
        </proposal-renderer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import VJsoneditor from 'v-jsoneditor/src/index'
import ProposalRenderer from '@/components/common/ProposalRenderer'

export default {
  name: 'ProposalDesigner',
  props: {
    value: Array
  },

  method: {},

  components: {
    VJsoneditor,
    ProposalRenderer
  },
  data: () => ({
    jsonOptions: { mode: 'code' },
    proposals: []
  }),
  watch: {
    proposals() {
      this.$emit('input', this.proposals)
    }
  },
  created() {
    if (typeof this.value !== 'undefined' && this.value.length > 0) {
      this.proposals = this.value
    }
  }
}
</script>

<style scoped></style>
